import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Alert, InfoCard, Loader, SortableTable, genericTexts } from 'hub-web-lib'
import { ACTIVITY } from 'js/constants/vocabulary'
import EasmApi from 'services/EasmApi'
import { UPDATE_NOTIFICATION_CONTENT } from 'js/constants/action-types'
import { action } from 'js/actions'
import store from 'js/store'
import { connect } from 'react-redux'
import 'scss/UpdateActivity/ActivityInfo.scss'
import { activityCardInfoDefault } from 'js/constants/enums/activity'
import { getActivityInfoCardData, getSelectedActivityTitle } from 'js/ui-helpers/activity'
import { getActivityInfoMetricsColumns, getActivityInfoMetricsTableData, getActivityMetricsValuesProps } from 'js/ui-helpers/metrics'
import BackButton from 'components/Assets/BackButton/BackButton'
import { ATTACK_SURFACE_MODULE } from 'js/constants/app-modules'

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser,
        dashboardSettings: state.dashboardSettings,
        currentUserOrgs: state.currentUserOrgs
    }
}

const EasmActivityInfoComponent = ({ currentUser, dashboardSettings, currentUserOrgs }) => {
    const currentOrgId = currentUser?.current_org
    const location = useLocation()
    const [isLoading, setIsLoading] = useState(true)
    const [currentActivityInfo, setCurrentActivityInfo] = useState({})
    const currentActivityTitle = getSelectedActivityTitle(currentActivityInfo)
    const easmValuesProps = getActivityMetricsValuesProps(dashboardSettings, ATTACK_SURFACE_MODULE)

    const getActivityInfo = async () => {
        let info = location?.state?.activity
        if (info) {
            setCurrentActivityInfo(info)
            return
        }
        const activityId = (location?.pathname || '').split('/')[3]*1
        const activity = await EasmApi.getActivity(activityId)
        if (!activity || activity.error) {
            store.dispatch(action(UPDATE_NOTIFICATION_CONTENT, { message: genericTexts.defaultText.deletedError(ACTIVITY), notificationType: 'error' }))
            return
        }  
        activity.metrics = await EasmApi.getActivityMetrics(activityId)
        if (!activity.metrics || activity.metrics.error) activity.metrics = []
        const org = currentUserOrgs.find(o => o.id === currentOrgId) || { id: currentOrgId }
        activity.organization = org?.name || currentOrgId
        setCurrentActivityInfo(activity)
    }

    const cardData = getActivityInfoCardData(activityCardInfoDefault, currentActivityInfo)
    const metricsTableData = getActivityInfoMetricsTableData(currentActivityInfo, easmValuesProps)
    const metricsTableColumns = getActivityInfoMetricsColumns(easmValuesProps)


    useEffect( async () => {
        await getActivityInfo()
        setIsLoading(false)
    }, [])

    return (
        <div className='page-content easm-info activity-info'>
            <div className='page-header'>
                <BackButton />
                <h1 id='easm-activity-info'>{ACTIVITY} {currentActivityTitle} Info</h1>
            </div>
            {isLoading ? <Loader /> : currentActivityInfo.id ? <div className='report-info-con info-card-con'>
                <InfoCard cardData={cardData} />
                <h2 id='easm-mertics'>Metrics</h2>
                <SortableTable columns={metricsTableColumns} tableData={metricsTableData} itemsPerPage={0} tableId='easm-activity-info-metrics-table' />
            </div> : <Alert message={`No data for this ${ACTIVITY}`} />}
        </div>
    )
}
const EasmActivityInfo = connect(mapStateToProps)(EasmActivityInfoComponent)
export default EasmActivityInfo